// Recovered compiled webpack factory 66640. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "assignLocation", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(96058);
  function a(e, t) {
    if (e.startsWith(".")) {
      let r = t.origin + t.pathname;
      return new URL((r.endsWith("/") ? r : r + "/") + e);
    }
    return new URL((0, n.addBasePath)(e), t.href);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
